import React, { Component } from 'react'
import Icon from './Icon'

type TemplateDownloaderFilename = 'purchaseOrders' |
  'inventories' |
  'licensePlate'
type TemplateDownloaderFilepaths = Record<TemplateDownloaderFilename, string>

interface TemplateDownloaderProps {
  text: string
  filename: TemplateDownloaderFilename
}

export default class TemplateDownloader
  extends Component<TemplateDownloaderProps> {
  filepaths: TemplateDownloaderFilepaths = {
    purchaseOrders: '/templates/purchaseOrders.csv',
    inventories: '/templates/inventories.csv',
    licensePlate: '/templates/licensePlate.csv'
  }

  render () {
    const { filename } = this.props
    return (
      <a
        className="mb-4 flex items-end cursor-pointer"
        href={this.filepaths[filename]}
        download={filename}>
        <Icon
          name="download-2"
          size="small"
          color="gray" />
        <p className="text-secondary ml-2 text-xs">
          {this.props.text}
        </p>
      </a>
    )
  }
}
